import ajax from '@/resources/myApi';
import vm from '@/main';

const service = {
  getBillingTerms,
  manageBillingTerms,
  deleteBillingTerms,
};

async function getBillingTerms() {
  try {
    const { data } = await ajax.get(`api/BillingTerm`, {
      name: 'BillingTerms',
      params: { pageNumber: 0, pageSize: 1 },
    });
    return data.items;
  } catch (error) {
    console.log('API Catch:',error.message);
    return { items: [], paging: {} };
  }
}

async function manageBillingTerms(dto) {
  try {
    if (dto.id) {
      var { data } = await ajax.put(`api/BillingTerm/${dto.id}`, {
        name: 'BillingTerm',
        body: dto,
      });
    } else {
      var { data } = await ajax.post(`api/BillingTerm`, {
        name: 'BillingTerm',
        body: dto,
      });
    }

    if (data.id) {
      vm.$snotify.success((dto.id) ? 'BillingTerm changes saved' : 'BillingTerm has been created', 'BillingTerm');

      return data.id;
    }
  } catch (error) {
    console.log('API Catch:',error.message);
    return {}
  }
}

async function deleteBillingTerms(id) {
  try {
    await ajax.delete(`api/BillingTerm/${id}`);
    vm.$snotify.success('BillingTerm has been removed', 'BillingTerm');
  } catch (error) {
    console.log('API Catch:',error.message);
  }
}

export default service;
